import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfigService } from '../services/app-config.service';

@Injectable() export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private router: Router,
         private config: AppConfigService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // const id1: string | any = localStorage.getItem('id1');
        // const id2: string | any = localStorage.getItem('id2');
        // const srtoken: string | any = localStorage.getItem('srtoken');
        const id1: string | any = sessionStorage.getItem('id1');
        const id2: string | any = sessionStorage.getItem('id2');
        const srtoken: string | any = sessionStorage.getItem('srtoken');
        srtoken
        request.clone()

        if (id1 && id2 && srtoken) {
            request = request.clone(
                { headers: request.headers.set('id1', id1) });
            request = request.clone(
                { headers: request.headers.set('id2', id2) });
            request = request.clone(
                { headers: request.headers.set('srtoken', srtoken) });
        }

        if (!request.headers.has('Content-Type') && !request.headers.has('enctype')) {
             request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
           // request = request.clone({ headers: request.headers.set('enctype', 'multipart/form-data') });
        }else if(request.headers.has('enctype')){
           // request = request.clone({ headers: request.headers.set('enctype', 'multipart/form-data') });
             request = request.clone({ headers: request.headers.set('access-control-allow-origin', '*') });
            request = request.clone({ headers: request.headers.set('Access-Control-Allow-Headers', 'Content-Type, Authorization') });
            request = request.clone({ headers: request.headers.set('Access-Control-Allow-Methods', '*') });
        }
        
        // Ignore absolute URLs
        if (request.url.startsWith('http')) {
            return next.handle(request);
        }

        request = request.clone({
            url: this.config.baseAPIUrl + request.url
        });


        request = request.clone({ headers: request.headers.set('Accept', 'application/json'), withCredentials: true });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    let id1: string | any = event.headers.get('id1');
                    let id2: string | any = event.headers.get('id2');
                    let srtoken: string | any = event.headers.get('srtoken')
                    sessionStorage.setItem("id1", id1);
                    sessionStorage.setItem("id2", id2);
                    sessionStorage.setItem("srtoken", srtoken);
                    // localStorage.setItem("id1", id1);
                    // localStorage.setItem("id2", id2);
                    // localStorage.setItem("srtoken", srtoken);
                }
                return event;
            }), catchError((error: HttpErrorResponse) => {
                if (error.status != 500 && this.router.url != '/Login') {
                    this.router.navigate(['/Error']);
                }
                return throwError(error);
            }));
    }
}
